import { useEffect, useState } from 'react'
import { createAuthenticatedAxiosInstance } from '../../utils/axios'
import { PaymentCard } from './PaymentCard'
import { IPaymentMethod } from '../../interfaces/IPaymentMethod'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { AxiosInstance } from 'axios'

interface BottomSectionProps {
    isUpperSectionLoaded: boolean;
    axiosInstance: AxiosInstance;
}

export const BottomSection = ({ isUpperSectionLoaded, axiosInstance }: BottomSectionProps) => {
    const [methods, setMethods] = useState<IPaymentMethod[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [modalMessage, setModalMessage] = useState<string>('')
    const navigate = useNavigate()

    useEffect(() => {
        fetchPaymentMethods()
    }, [])

    const fetchPaymentMethods = async () => {
        try {
            const response = await axiosInstance.get('/payment-methods')
            setMethods(response.data)
            setLoading(false)
        } catch (err) {
            setError('Error al cargar los métodos de pago')
            setLoading(false)
        }
    }

    const handleStatusChange = async (methodId: string) => {
        try {
            const method = methods.find(m => m.id === methodId)
            if (!method) return false

            const response = await axiosInstance.put(`/payment-methods/${methodId}`, {
                is_active: !method.is_active
            })

            if (response.status === 200) {
                setMethods(methods.map(m => 
                    m.id === methodId ? { ...m, is_active: !m.is_active } : m
                ))
                return true
            }
            return false
        } catch (err) {
            setModalMessage('Error al actualizar el método de pago')
            setShowModal(true)
            return false
        }
    }

    if (loading) return <div>Cargando...</div>
    if (error) return <div>{error}</div>

    return (
        <div className="p-4">
            <h2 className="mb-4">Métodos de Pago</h2>
            <div className="payment-methods-container">
                {methods.map(method => (
                    <PaymentCard
                        key={method.id}
                        method={method}
                        onChange={() => handleStatusChange(method.id)}
                    />
                ))}
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={() => setShowModal(false)}>
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
